// From StackOverflow https://stackoverflow.com/a/48592904/419002
const getDeferred = () => {
  let resolve;
  let reject;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return [promise, resolve, reject];
};

export default getDeferred;
